module.exports = __webpack_public_path__ + "img/back01.3e81f994.png";